export default __webpack_public_path__ + "static/feature-samples-d94fed13ce8aef3d1d7cdd7cbe2168de.webp";